import { ICourseReportData } from "../interfaces/reports-courses.interface";
import { IProgramReportResponse } from "../interfaces/reports-program.interface";
import { IStudentReportData } from "../interfaces/reports-students.interface";
import http from "./axios";

export const getReportProgramByParams = async (
  institutionId: string,
  params?: any,
) => {
  try {
    const queryString = appendParams(params);
    const response = await http.get<IProgramReportResponse>(
      `reports/institution/${institutionId}?${queryString}`,
    );

    response.data.totalByCourseCode.forEach((course) => {
      course.payment = course.payment / 100;
    });

    return response.data;
  } catch (err) {
    console.error(err);
  }
};

export const getReportCoursesByParams = async (params?: any) => {
  try {
    const queryString = appendParams(params);
    const response = await http.get<ICourseReportData>(
      `reports/courses?${queryString}`,
    );

    response.data.studentsByYear.forEach((course) => {
      course.paid = course.paid / 100;
    });

    return response.data;
  } catch (err) {
    console.error(err);
  }
};

export const getReportStudentsByParams = async (id: number) => {
  try {
    const response = await http.get<IStudentReportData>(`reports/users/${id}`);

    response.data.totalCourses.forEach((course) => {
      course.paid = course.paid / 100;
    });

    return response.data;
  } catch (err) {
    console.error(err);
  }
};

const appendParams = (params: any) => {
  const queryString = new URLSearchParams();
  if (params?.startDate) queryString.append("startDate", params.startDate);
  if (params?.endDate) queryString.append("endDate", params.endDate);
  if (params?.term) queryString.append("term", params.term);
  if (params?.year) queryString.append("year", params.year);
  if (params?.courses) queryString.append("courses", params.courses);

  return queryString.toString();
};

interface ICourseReport {
  id: number;
  code: string;
  name: string;
}

export const getReportAllCourses = async () => {
  try {
    const response = await http.get<ICourseReport[]>(`courses/all`);
    return response.data
      .filter(
        (value, index, self) =>
          index === self.findIndex((course) => course.code === value.code),
      )
      .map((c: ICourseReport) => ({
        value: c.code,
        id: c.id,
      }));
  } catch (err) {
    console.error(err);
  }
};

interface IStudent {
  key: number;
  id: number;
  firstName: string;
  lastName: string;
}

export const getReportAllStudents = async () => {
  try {
    const response = await http.get<IStudent[]>(`users/all-students`);
    return response.data
      .sort((a, b) => a.id - b.id)
      .map((s: IStudent) => ({
        key: s.id,
        id: s.id,
        value: `${s.lastName}, ${s.firstName}`,
      }));
  } catch (err) {
    console.error(err);
  }
};
